import http from '../libs/http';

export const getMerchantDetails = (merchantId) => {

    const endpoint = `/v1/merchants/${merchantId}`;
    return http({endpoint});
};
